import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Empowering Businesses with Cutting-Edge AI Solutions"} subTitle={"Join Us"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Request A Quote"} />

      </div>
    </section>

  );

};

export default Banner;